import styled from '@xstyled/styled-components';

interface LinkProps {
  display?: string;
  showShadow?: boolean;
}

export const Link = styled.a<LinkProps>`
  padding: 14px xl;
  border-radius: md;
  font-weight: bold;
  background-color: accentDark;
  color: var(--color-on-accent) !important;
  border: 1px solid var(--color-accent-edge);
  display: ${({ display = 'block' }) => display};
  ${({ showShadow }) =>
    showShadow ? ' box-shadow: 0 0 10px rgba(255, 255, 255, 0.5);' : ''}
  &:hover {
    background-color: accentDark;
    opacity: 0.8;
  }
  &:disabled {
    background-color: greyLight;
    color: greyDark;
  }
`;
